import React, { useState } from 'react';
import { Accordion, Button, Pagination } from 'react-bootstrap';

export function PaginatedAccordion ({ pseudocodes, t, hideSelectOrigin, handleSetOrigin, handleSetDestination }){
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  // Calcula los �ndices de los elementos de la p�gina actual
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = pseudocodes.slice(indexOfFirstItem, indexOfLastItem);

  // Calcula el n�mero total de p�ginas
  const totalPages = Math.ceil(pseudocodes.length / itemsPerPage);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <>
      <Accordion defaultActiveKey="0">
        {currentItems.map((ps) => (
          <Accordion.Item key={ps.pseudoCodeId} eventKey={ps.pseudoCodeId.toString()}>
            <Accordion.Header>{ps.pseudoCodeText}</Accordion.Header>
            <Accordion.Body>
              <div>
                <div className="d-flex flex-row justify-content-between">
                  <p>
                    <strong>{t('Id')} : </strong>
                    {ps.pseudoCodeId}
                  </p>
                  <p>
                    <strong>{t('ccPseudoCode')} : </strong>
                    {ps.pseudoCode}
                  </p>
                  <p>
                    <strong>{t('ccPseudoCodeText')} : </strong>
                    {ps.pseudoCodeText}
                  </p>
                  {ps.pseudoCodeDescription !== ' ' && (
                    <p>
                      <strong>{t('ccPseudoCodeDescription')} : </strong>
                      {ps.pseudoCodeDescription}
                    </p>
                  )}
                </div>
                <div className="d-flex flex-row justify-content-between">
                  {!hideSelectOrigin && (
                    <Button variant="outline-dark" onClick={() => handleSetOrigin(ps)}>
                      {t('ccSelectLikeOrigin')}
                    </Button>
                  )}
                  <Button variant="outline-danger" onClick={() => handleSetDestination(ps)}>
                    {t('ccSelectLikeDestination')}
                  </Button>
                </div>
              </div>
              <div className="d-flex justify-content-end"></div>
            </Accordion.Body>
          </Accordion.Item>
        ))}
          </Accordion>

      {/* Controles de Paginaci�n */}
          <Pagination size="sm" className="AuditsList__pagination" style={{'margin-top': '1em'}}>
          <div className="AuditsList__paginationText"> {t('pPage')} {currentPage} {t('pFrom')} {totalPages}</div>
          <Pagination.First disabled={currentPage === 1} onClick={() => handlePageChange(1)} />
          <Pagination.Prev
            disabled={currentPage === 1}
            onClick={() => handlePageChange(currentPage - 1)}
          />
          <Pagination.Next
            disabled={currentPage === totalPages}
            onClick={() => handlePageChange(currentPage + 1)}
          />
          <Pagination.Last
            disabled={currentPage === totalPages}
            onClick={() => handlePageChange(totalPages)}
          />
        </Pagination>
    </>
  );
};
